import { useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Cat_Indices_Response } from '@opensearch-project/opensearch/api/cat/indices'

import { SellTreezService } from '@/services/sell-treez'
import { Param } from '@/models/params'

import { IndexWithName } from '../data/types'
import { EntitiesById } from '../data/entities'

export const useSellTreezIndexes = () => {
  const { sellTreezId } = useParams<Param>()
  const queryKey = ['sell-treez-indexes', sellTreezId]

  const getIndexes = useCallback(async () => {
    const response = await SellTreezService.getSellTreezIndexes(sellTreezId as string)
    const indices = response.data as Cat_Indices_Response
    const indicesWithName: IndexWithName[] = indices.body.map((index) => {
      const id = index.index?.split('product_')?.[1] ?? ''

      return {
        ...index,
        posEntity: id,
        entityName: EntitiesById[id]?.Name ?? '',
      }
    })
    return indicesWithName
  }, [sellTreezId])

  const { data, isLoading, refetch } = useQuery({
    queryKey,
    queryFn: getIndexes,
    enabled: !!sellTreezId?.length,
  })

  return { indexes: data ?? [], isLoading, refetch }
}
